import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SalaryBatch, ConsultantSalary } from "../../../models/Salary";
import AppText from "../../Core/AppText/AppText";
import Flex from "../../../components/Layout/Flex";
import SalaryJournalConsultants from "./SalaryJournalConsultants";
import SalaryJournalSummary from "./SalaryJournalSummary";
import { DATE_TIME_FORMAT_TYPES } from "../../../configs/constants/DateTimeFormatTypes";
interface SalaryJournalProps {
	journal: SalaryBatch;
	inputRef?: any;
}

const SalaryJournal: React.FC<SalaryJournalProps> = ({
	journal: {
		metadata,
		from,
		to,
		pool,
		consultants,
		totalHourlyPay,
		totalGrossPay,
		totalDeduction,
		totalHolidayPay,
		totalSickPay,
		totalQualifyingDeduction,
		totalOb,
	},
	inputRef,
}) => {
	const { t } = useTranslation();

	return (
		<StyledJournalViewer ref={inputRef}>
			<AppText margin="0 0 20px 0">
				{t("salary.journal.salaryJournal")}&nbsp;
				{moment(metadata.created).format(DATE_TIME_FORMAT_TYPES.DATE)}
			</AppText>
			<Flex margin="0 0 7px 0">
				<AppText size="l" color="black">
					{t("salary.journal.salaryPeriod")}:
				</AppText>
				<AppText size="l" color="black">
					&nbsp;
					{moment(from).format(DATE_TIME_FORMAT_TYPES.DATE) +
						" - " +
						moment(to).format(DATE_TIME_FORMAT_TYPES.DATE)}
				</AppText>
			</Flex>
			<Flex margin="0 0 7px 0">
				<AppText size="l" color="black">
					{t("POOL")}:
				</AppText>
				<AppText size="l" color="black">
					&nbsp; {pool || t("salary.journal.all")}
				</AppText>
			</Flex>
			<Flex margin="0 0 40px 0">
				<AppText size="l" color="black">
					{t("salary.journal.numberOfPeople")}:
				</AppText>
				<AppText size="l" color="black">
					&nbsp; {consultants.length}
				</AppText>
			</Flex>

			{consultants.map((consultant: ConsultantSalary) => (
				<SalaryJournalConsultants consultant={consultant} key={consultant.id} />
			))}

			<SalaryJournalSummary
				totalGrossPay={totalGrossPay}
				totalHourlyPay={totalHourlyPay}
				totalQualifyingDeduction={totalQualifyingDeduction}
				totalHolidayPay={totalHolidayPay}
				totalSickPay={totalSickPay}
				totalDeduction={totalDeduction}
				totalOb={totalOb ?? 0}
			/>
		</StyledJournalViewer>
	);
};

export default SalaryJournal;

const StyledJournalViewer = styled.div`
	width: 837px;
	padding: 30px 50px 50px 50px;
	background: ${({ theme }) => theme.colors.COLOR_WHITE};
	table {
		border-collapse: collapse;
		width: 100%;

		th {
			font-weight: ${({ theme }) => theme.fontWeight.FONT_WEIGHT_MEDIUM};
			font-size: ${({ theme }) => theme.fontSizes.FONT_SIZE_L};
		}
		td {
			font-size: ${({ theme }) => theme.fontSizes.FONT_SIZE_L};
		}
	}
	& > p {
		font-size: 2rem;
		color: ${({ theme }) => theme.colors.COLOR_BLACK};
		font-weight: 700;
	}
	.full-name {
		text-align: left;
	}
	.headings-cell {
		padding-bottom: 14px;
	}
	.right-align {
		text-align: right;
	}
	.gross-salary {
		padding-top: 12px;
	}
	.total-gross {
		padding-top: 10px;
	}
	.total-gross-row {
		border-top: 1px solid ${({ theme }) => theme.colors.COLOR_BLACK};
	}
`;
